import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState as s, useEffect as o } from "react";
import { disposables as t } from '../utils/disposables.js';
function p() {
  let _s = s(t),
    _s2 = _slicedToArray(_s, 1),
    e = _s2[0];
  return o(() => () => e.dispose(), [e]), e;
}
export { p as useDisposables };